import { endOfDay, isBefore, startOfToday } from 'date-fns';

export function isDateOverdue(date: Date): boolean {
    return isBefore(endOfDay(date), startOfToday());
}
